import {
  ConsentOrdersParentingSchema,
  InitialDetails,
  ParentingIcon,
  RadioSelect,
  RangeSlider,
  TextArea
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}
export default function ParentingAndHomemakerContributions({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, watch, setValue, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersParentingSchema(store))
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <ParentingIcon classes="w-20 h-14 mx-auto mb-5" />

        <h3 className="text-center">
          {store?.children?.if_children === "yes" ? "Parenting & Homemaker Contributions" : "Homemaker Contributions"}
        </h3>
      </div>

      <p className="text-gray-500 text-sm mb-4">
        These questions relate to contributions both during the relationship and after separation.
      </p>

      <RadioSelect
        title="Were homemaker contributions generally equal?"
        subTitle="Homemaker contributions refers to domestic duties such as cooking, cleaning, washing, ironing, gardening and general maintenance of the house."
        control={control}
        name="contributions.homemaker_contribution_equal"
        id="contributions.homemaker_contribution_equal"
        options={["yes", "no"]}
        classes="col-span-1"
        onChange={val => {
          if (val === "no") {
            setValue("contributions.contribution_chores", "50");
          } else {
            setValue("contributions.contribution_chores", "");
            setValue("contributions.contribution_chores_comments", "");
          }
        }}
      />
      {watch("contributions.homemaker_contribution_equal") === "no" ? (
        <>
          <RangeSlider
            title={`Overall, how did you and ${store?.spouse?.first_name} contribute to the household chores?`}
            control={control}
            name="contributions.contribution_chores"
            id="contributions.contribution_chores"
            exName={store?.spouse?.first_name || "N/A"}
          />

          <TextArea
            title="Please give details why contribution to the household chores was not equal"
            control={control}
            name="contributions.contribution_chores_comments"
            id="contributions.contribution_chores_comments"
            placeholder="details"
          />
        </>
      ) : null}

      {store?.children?.if_children === "yes" ? (
        <>
          <RadioSelect
            title="Were parenting contributions generally equal?"
            control={control}
            name="contributions.parenting_contribution_equal"
            id="contributions.parenting_contribution_equal"
            options={["yes", "no"]}
            classes="col-span-1"
            subTitle="Parenting contributions means raising the children, taking them to school, extracurricular activities, assisting with health, wellbeing and educational needs"
            onChange={val => {
              if (val === "no") {
                setValue("contributions.contribution_children_caring", "50");
              } else {
                setValue("contributions.contribution_children_caring", "");
                setValue("contributions.contribution_children_caring_comments", "");
              }
            }}
          />

          {watch("contributions.parenting_contribution_equal") === "no" ? (
            <>
              {store?.children?.if_children !== "yes" ? (
                <RangeSlider
                  title="Overall, how did you both contribute to raising and caring for the children of the relationship?"
                  control={control}
                  name="contributions.contribution_children_caring"
                  id="contributions.contribution_children_caring"
                  exName={store?.spouse?.first_name || "N/A"}
                />
              ) : null}

              <TextArea
                title="Please give details why contribution towards caring for the children was not equal"
                control={control}
                name="contributions.contribution_children_caring_comments"
                id="contributions.contribution_children_caring_comments"
                placeholder="details"
              />
            </>
          ) : null}
        </>
      ) : null}
    </form>
  );
}

/*
list of Australian States
Overseas 

show the country (drop down)
shw input box - overseas_state

*/
